import styled from 'styled-components';

export const ScPriceListPreviewImageWrapper = styled.div`
  position: relative;
  align-self: center;
  height: 80%;
`;
